import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.PortalFirmTypeEnumSortEnum>
) {
  const { pagination, sort } = params;

  const {
    portalFirmTypeEnumList: { items: data, total },
  } = await sdk.getListPortalFirmTypeEnum(filterSortPage({ sort, pagination }));

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { portalFirmTypeEnum: data } = await sdk.getOnePortalFirmTypeEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { portalFirmTypeEnumMany: data } = await sdk.getManyPortalFirmTypeEnum({
    ids,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const portalFirmTypeEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
